import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';

class PatientImportProgress extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			ready: false,
			isLoading: false,
            fileReady: false,
			userID: '',
            fileID: '',
			formData: {
                fileSrc: {
                    dataUri: '',
                    fileName: '',
                    fileExtension: ''
                }
            },
            patientID: this.props.match.params.id
		}
	}

	componentWillMount() {
		var self = this;
		Api.parseToken(this.state.token, function(response) {
			self.setState({
				userID: response.id
			});
		});
	}

	onFileChange = (event) => {
        var reader = new FileReader();
        var file = event.target.files[0];
        var formData = this.state.formData;
        reader.onload = (upload) => {
            formData['fileSrc']['dataUri'] = upload.target.result;
            formData['fileSrc']['fileName'] = file.name;
            formData['fileSrc']['fileExtension'] = file.name.match(/\.[0-9a-z]+$/i);
            var extension = formData['fileSrc']['fileExtension'][0];
            if(extension !== '.csv' && extension !== '.xls' && extension !== '.xlsx') {
                alert("Only CSV files allowed!");
                document.getElementById('fileSrc').value = '';
                return false;
            } else {
                this.setState({
                    formData: formData
                });
            }
        };
        reader.readAsDataURL(file);
    }

    uploadFile = () => {
        var self = this;
    	if(this.state.formData.fileSrc.dataUri === "") {
    		alert("No file selected!");
    		return false;
    	} else {
    		this.setState({
    			isLoading: true
    		}, function() {
    			Api.uploadFile(JSON.stringify({ token: this.state.token, userID: this.state.userID, fileSrc: this.state.formData.fileSrc }), function(response) {
    				if(response.status === "Uploaded") {
                        self.setState({
                            fileReady: true,
                            isLoading: false,
                            fileID: response.id
                        });
                    }
    			});
    		});
    	}
    }

    render() {
    	return(
    		<div className="blockCtr patients br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/files" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>File Import</h3>
    			</div>
    			<div className="blockInfo">
                    <div style={{ display: (this.state.fileReady ? 'none' : 'block') }}>
    					<p>
    						In this section you will be able to upload a CSV file containing the complete progress information.<br /><br />
    						After you upload the file, please match the corresponding columns on the actual database against the columns on your file.<br /><br />
    						<strong>Make sure that the first row of your file contains the names of the columns.</strong><br /><br />
							<strong>For a better and easier performance, it is recommended that all dots (.) are removed from the names of the columns of the file. For example, if a header name is Patient.number, try to change it to Patientnumber (without the dot). This will make the auto mapping of the columns a lot faster.</strong><br /><br />
                            <strong>Also make sure that your CSV file contains a column matching patients' ID (Patientnumber).</strong>
    					</p>
    					<input type="file" multiple="no" className="input4 br5 anim1" id="fileSrc" onChange={this.onFileChange} accept=".csv" />
    					{this.state.isLoading ? <img src={Preloader} alt="Fresenius Preloader" className="preloader2" /> : null}
    					<div className="row stepConfig" style={{paddingTop: 20}}>
    						<div className="col-12 ar">
    							<button className="goBtn btn br5 anim1" onClick={this.uploadFile} style={{display: 'inline-block'}}>Upload</button>
    						</div>
    					</div>
                    </div>
                    <div style={{ display: (this.state.fileReady ? 'block' : 'none') }}>
                        Your file is ready to be mapped.
                        <div className="row stepConfig" style={{paddingTop: 20}}>
                            <div className="col-12 ar">
                                <Link className="goBtn btn br5 anim1" to={'/files/import/map/' + this.state.fileID} style={{display: 'inline-block'}}>Map file</Link>
                            </div>
                        </div>
                    </div>
    			</div>
    		</div>
    	);
    }
}

export default PatientImportProgress;



// WEBPACK FOOTER //
// ./src/components/FilesImport.js